import React, { useState, useEffect, Fragment } from 'react';
import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import FormLabel from "@mui/material/FormLabel";
// import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import EastIcon from "@mui/icons-material/East";
import LoadingButton from '@mui/lab/LoadingButton';
import { FormControl, MenuItem, InputLabel, Select } from "@mui/material";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import moment from 'moment';

import { useForm } from "react-hook-form";

import CameraComponent from '../CameraComponent';

const FACING_MODE_USER = { facingMode: 'user' }; // Front Camera
const FACING_MODE_ENVIRONMENT = { facingMode: { exact: 'environment' } }; // Back Camera

const AllRoundPhotoItems = [
  { id: 1, displayFormat: 'A', name: 'หน้าซ้าย', image: 'assets/front_left.png' },
  { id: 2, displayFormat: 'A', name: 'หน้าตรง', image: 'assets/front.png' },
  { id: 3, displayFormat: 'A', name: 'หน้าขวา', image: 'assets/front_right.png' },
  { id: 4, displayFormat: 'A', name: 'หลังซ้าย', image: 'assets/back_left.png' },
  { id: 5, displayFormat: 'A', name: 'หลังตรง', image: 'assets/back.png' },
  { id: 6, displayFormat: 'A', name: 'หลังขวา', image: 'assets/back_right.png' },
  { id: 7, displayFormat: 'A', name: 'ห้องเครื่องยนต์', image: 'assets/engine.png' },
  { id: 8, displayFormat: 'A', name: 'คอนโซล', image: 'assets/front_console.png' },
  // { id: 1, displayFormat: 'A', name: 'หน้า', image: 'assets/aaa.png' },
];
// ถ้าเกิน 3 เอาแถวละ 3 ถ้าไม่ถึง 3 ขยายให้เต็มบรรทัด
const itemsCount = AllRoundPhotoItems.length>3?3:AllRoundPhotoItems.length;
const itemsCol = Math.floor(12/itemsCount);

export default function AllRoundPhotoForm({ onSave, dataStep, saveAndBack, btnLoading }) {
    const [gender, setGender] = useState("");
    // const [birthday, setBirthday] = useState("");
    // const [is_punish, setIs_punish] = useState("1");
    // const [education_qual, setEducation_qual] = useState('');
    // const [educationList, setEducationList] = useState([
    //     "ต่ำกว่ามัธยมศึกษาตอนปลาย / ปวช.",
    //     "มัธยมศึกษาตอนปลาย / ปวช.",
    //     "อนุปริญญา / ปวส.",
    //     "ปริญญาตรี",
    //     "ปริญญาโท หรือสูงกว่า"
    // ]);
    const [previousData, setPreviousData] = useState(null);
    const [capturedImages, setCapturedImages] = useState(null);

    const { register, formState: { errors }, handleSubmit, setValue, reset } = useForm({});
    // const { register, formState: { errors }, handleSubmit, setValue, reset } = useForm({});
    // const [user, setUser] = useState(null);

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        // reset form with previousData data
        reset(previousData);
    }, [previousData]);

    const onSubmit = (data) => {
        console.log("onSubmit data",data);
        console.log("capturedImages", data.capturedImages);
        // console.log("count", data.capturedImages.length);

        if(data.capturedImages){
            let arrImages = data.capturedImages;
            for (let i = 0; i < arrImages.length; i++) {
                const value = arrImages[i];
                if (!value) {
                    console.log("index",i,"is null");
                    alert("กรุณาถ่ายรูปรอบคันให้ครบ ก่อนกดถัดไป");
                    return;
                }
            }
        }
        console.log("next");
        onSave(data);
    };

    function getData() {
        // console.log("getData",dataStep);
        if (dataStep !== "") {
            setCapturedImages(dataStep.capturedImages);
            setPreviousData({
                capturedImages: dataStep.capturedImages,
    //             lastname: dataStep.lastname,
    //             gender: dataStep.gender,
    //             education_desc: dataStep.education_desc,
            })
    //         console.log(dataStep);
    //         setIs_punish(dataStep.is_punish !== null ? dataStep.is_punish : "0");
    //         setGender(dataStep.gender);
    //         setBirthday(dataStep.birthday);
    //         setEducation_qual(dataStep.education_qual);
        }
    }

    const handleCapture = (capturedImages) => {
        // console.log("handleCapture",capturedImages);
        // console.log("handleCapture dataStep",dataStep);
        setValue('capturedImages', capturedImages);
        setCapturedImages(capturedImages);
    }

    const handleRemoveImage = (index, newImages) => {
        // console.log("handleRemoveImage index", index, "newImages", newImages);
        setValue('capturedImages', newImages);
        setCapturedImages(newImages);
    }

    const handleBack = () => {
        // console.log("new handleBack", data);
        // console.log("capturedImages",capturedImages);
        // console.log("handleBack datastep",dataStep);
        // setCapturedImages(dataStep.capturedImages);
        // setValue('imageSrc', imageSrc);
        // setValue('capturedImages', capturedImages);
        saveAndBack(capturedImages);
    }

    return (
        <React.Fragment>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>
                        <CameraComponent items={AllRoundPhotoItems} itemsCol={itemsCol} 
                            displayFormat='A'   // A: cannot capture with vertical layout
                            onCapture={handleCapture}
                            onRemoveImage={handleRemoveImage}
                            previousData={dataStep.capturedImages?dataStep.capturedImages:null}
                            uploadAble={false}
                        />
                </Grid>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >

                    <Button onClick={handleBack}
                        sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                    >
                        ย้อนกลับ
                    </Button>
                    {/*<Button
                        variant="contained"
                        type="submit"
                        endIcon={<EastIcon />}
                        sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                    >
                        ถัดไป old
                    </Button>*/}
                    <LoadingButton
                        variant="contained"
                        type="submit"
                        endIcon={<EastIcon />}
                        sx={{ mt: 3, ml: 1, position: 'static' }}
                        // เดิมของ MUI เป็น position: 'relative' แล้วมันไปทับกับ position ของกล้อง
                        loading={btnLoading}
                        loadingPosition="start"
                    >
                        ถัดไป
                    </LoadingButton>

                    {/*
                    <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                        ย้อนกลับ
                    </Button>

                    <LoadingButton
                        type="submit"
                        loading={isLoading}
                        loadingPosition="end"
                        endIcon={<EastIcon />}
                        variant="contained"
                        sx={{ mt: 3, ml: 1 }}
                    >
                        สมัคร
                    </LoadingButton> 
                    */}
                    
                </Box>
            </form>
        </React.Fragment>
    );
}
